import { PROJECT_MAP } from './config';

export const FUTURES_NAVIGATOR_BAR_CONFIG_MAP = new Map([
	[
		'futures-lang', // 路由页
		{
			theme: 'dark',
			footerTheme: 'dark',
			size: 'small',
			offset: 80,
		},
	],
	[
		'infomation-lang', // 合约 - 规则说明页
		{
			theme: 'light',
			size: 'normal',
			offset: 80,
		},
	],
]);

// 不需要登陆的菜单集合
// to的地址，不需要指定语言后缀，默认会将语言自动添加在末尾
// to的地址如果需要指定语言后缀的位置时，可以通过locale来进行占位
// 如果project无法与当前项目的project字段匹配时，跳转到指定的二级域名下，并且hostname如果是localhost或者ip时，跳转到根据本地的ENV来判断
export const FUTURES_COMMON_ROUTES_MAP = new Map([
	[
		'HOME',
		{
			value: 'home',
			name: 'futures-navigator-bar.common_route_home',
			to: '/',
			project: PROJECT_MAP.MASTER,
			// sensorData: {
			//   sensorEventName: 'ClickTopBar',
			//   module_name: '现货首页',
			//   button_name: '现货首页',
			// },
		},
	],
	[
		'FUTURES_USDT',
		{
			value: 'futures_usdt',
			name: 'bmui-navigator-bar.common_route_trade_futures_usdt',
			icon: 'icon-bmui-navigator-trade-futures-usd',
			iconSize: 20,
			intro: 'bmui-navigator-bar.common_route_desc_trade_futures_usdt',
			to: {
				path: '/',
				query: { coinType: 'USD' },
			},
			project: PROJECT_MAP.DERIVATIVES,
			// sensorData: {
			//   sensorEventName: 'ClickTopBar',
			//   module_name: '合约',
			//   button_name: '合约（U本位）',
			// },
		},
	],
	[
		'FUTURES_COIN',
		{
			value: 'futures_coin',
			name: 'bmui-navigator-bar.common_route_trade_futures_coin',
			to: {
				path: '/',
				query: { coinType: 'COIN' },
			},
			project: PROJECT_MAP.DERIVATIVES,
			// sensorData: {
			//   sensorEventName: 'ClickTopBar',
			//   module_name: '合约',
			//   button_name: '合约（币本位）',
			// },
		},
	],
	[
		'FUTURES_COPY',
		{
			value: 'futures_copy',
			name: 'bmui-navigator-bar.common_route_trade_futures_copy',
			intro: 'bmui-navigator-bar.common_route_desc_trade_futures_copy',
			// label: 'Beta',
			to: {
				path: '/futures-copy-trading',
				query: {},
			},
			project: PROJECT_MAP.MASTER,
			// sensorData: {
			//   sensorEventName: 'ClickTopBar',
			//   module_name: '合约',
			//   button_name: '合约跟单',
			// },
		},
	],
	[
		'FUTURES_INFO',
		{
			value: 'futures_info',
			name: 'futures-navigator-bar.common_route_info',
			to: {
				path: '/information',
			},
			project: PROJECT_MAP.DERIVATIVES,
			// sensorData: {
			//   sensorEventName: 'ClickTopBar',
			//   module_name: '合约交易信息',
			//   button_name: '合约交易信息',
			// },
		},
	],
	[
		'BIG_GIVEAWAY',
		{
			value: 'big_giveaway',
			name: 'bmui-navigator-bar.common_route_big_giveaway',
			to: '/big-giveaway',
			icon: 'icon-bmui-hot',
			iconSize: 18,
			hot: true,
			project: PROJECT_MAP.MASTER,
			sensorData: {
				sensorEventName: 'ClickTopBar',
				module_name: '活动',
				button_name: '活动',
			},
		},
	],
	[
		'BONUSGIVEAWAY',
		{
			value: 'bonus-giveaway',
			name: 'bmui-navigator-bar.common_route_bonus_giveaway',
			to: '/bonus-giveaway',
			icon: 'icon-bmui-hot',
			iconSize: 18,
			project: PROJECT_MAP.MASTER,
			sensorData: {
				sensorEventName: 'ClickTopBar',
				module_name: '赠金活动',
				button_name: '赠金活动',
			},
		},
	],
	[
		'NEWUSERS',
		{
			value: 'new-users',
			name: 'bmui-navigator-bar.common_route_new_users',
			to: '/activity/new-users',
			icon: 'icon-bmui-hot',
			iconSize: 18,
			project: PROJECT_MAP.MASTER,
			sensorData: {
				sensorEventName: 'ClickTopBar',
				module_name: '合约新用户活动',
				button_name: '合约新用户活动',
			},
		},
	],
	[
		'BWTC',
		{
			value: 'BWTC',
			name: 'bmui-navigator-bar.common_route_bwtc',
			to: '/BWTC',
			icon: 'icon-bmui-hot',
			iconSize: 18,
			project: PROJECT_MAP.MASTER,
			sensorData: {
				sensorEventName: 'ClickTopBar',
				module_name: '全球交易大赛',
				button_name: '全球交易大赛',
			},
		},
	],
	[
		'BONUS-GIVEAWAY-05',
		{
			value: 'BONUS-GIVEAWAY-05',
			name: 'bmui-navigator-bar.common_route_bonus_giveaway05',
			to: '/activity/bonus-giveaway-05',
			icon: 'icon-bmui-hot',
			iconSize: 18,
			project: PROJECT_MAP.MASTER,
			sensorData: {
				sensorEventName: 'ClickTopBar',
				module_name: '赠金',
				button_name: '赠金',
			},
		},
	],
	// [
	// 	'LUNAR-NEW-YEAR',
	// 	{
	// 		value: 'LUNAR-NEW-YEAR',
	// 		name: 'futures-navigator-bar.common_route_lunar_new_year',
	// 		to: '/activity/Lunar-New-Year',
	// 		icon: 'icon-bmui-hot',
	// 		iconSize: 18,
	// 		project: PROJECT_MAP.MASTER,
	// 		sensorData: {
	// 			sensorEventName: 'ClickTopBar',
	// 			module_name: '赠金',
	// 			button_name: '赠金',
	// 		},
	// 	},
	// ],
]);
